<template>
    <div
        class="w-full p-8 lg:pl-16 flex items-center justify-between flex-1 bg-white"
    >
        <div class="flex-1 min-w-0 mt-4">
            <h2 class="text-2xl break-words font-bold text-gray-900 sm:text-3xl">{{ title }}</h2>
            <p class="mb-6">{{ subtitle }}</p>
            <span
                v-if="tag"
                class="inline-flex items-center px-6 py-2 rounded-lg font-light leading-5 bg-indigo-100 text-indigo-800 md:text-xl"
            >{{ tag }}</span>
        </div>
        <div class="flex-shrink-0 flex w-48 md:w-56 pl-4">
            <img
                src="@/assets/img/logo.jpg"
                width="100%"
                alt="Logo mkm - musik &amp; kunst schulen management"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'form-header',
    props: {
        title: String,
        subtitle: String,
        tag: String,
    },

    data: function() {
        return {}
    },

    computed: {},
    methods: {},
}
</script>